import { render, staticRenderFns } from "./AssetTypeList.vue?vue&type=template&id=8ac133de&scoped=true&"
import script from "./AssetTypeList.vue?vue&type=script&lang=ts&"
export * from "./AssetTypeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac133de",
  null
  
)

export default component.exports